<template>
  <svg width="32" height="32" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <!-- Transparent circle with white border -->
    <circle cx="50" cy="50" r="45" fill="none" stroke="white" stroke-width="5" />

    <!-- White question mark -->
    <text
      x="50%"
      y="50%"
      text-anchor="middle"
      fill="white"
      font-size="50"
      font-family="Arial"
      dy=".3em"
    >
      ?
    </text>
  </svg>
</template>
